import React, { useEffect, useState, useRef } from "react";

function ParticlesFX() {
  const [particles, setParticles] = useState([]);
  const particleIdRef = useRef(0);
  const styleRef = useRef(null);

  useEffect(() => {
    const intervalId = setInterval(generator, 100);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const generator = () => {
    if (Math.random() > 0.9) {
      console.log('create particle');
      const id = particleIdRef.current++;
      const particleRotation = Math.random() * 360;
      const randomTiming = (Math.random() * 5) + 5;
      const randomSize = (Math.random() * 1) + .5;
      const animationName = `particleAnimation${id}`; 
      const rotationKeyframes = `
      @keyframes ${animationName} {
        0% { transform: rotate(${150 - (Math.random() * 300)}deg); }
        100% { transform: rotate(${150 - (Math.random() * 300)}deg); }
      }`;

      if (!styleRef.current) {
        styleRef.current = document.createElement('style');
        document.head.appendChild(styleRef.current);
      }
      styleRef.current.innerHTML += rotationKeyframes;

      setParticles(prevParticles => [...prevParticles, { id, rotation: particleRotation, timing: randomTiming, animName: animationName, size: randomSize }]);
    }
  };

  const createParticle = ({ id, rotation, timing, animName, size }) => {
    return (
      <div
        className="particle-container"
        key={id}
        style={{ transform: `rotate(${rotation}deg)` }}
      >
        <div
          className="particle-trajectory"
          onAnimationEnd={() => handleAnimationEnd(id)}
          style={{ animationDuration: `${timing}s`}}
        >
          <div className="particle" style={{transform: `translateX(-50%) scale(${size})`}}>
            <div className="particle-image" style={{animation: `${animName} ${timing}s linear forwards`}}></div>
          </div>
        </div>
      </div>
    );
  };

  const handleAnimationEnd = (id) => {
    console.log('removed', id);
    setParticles(prevParticles => prevParticles.filter(p => p.id !== id));
  };

  return (
    <div className="particlesFX">
      <div className="particles-container">
        {particles.map(particle => createParticle(particle))}
      </div>
    </div>
  );
}

export default ParticlesFX;